'use strict';

/**
 * Google Map Function
 */
$.fn.googleMap = function(options) {
    var el = $(this);

    var settings = $.extend({
        "lat": "37.979561",
        "lng": "23.728487",
        "zoom": 13,
        "styles": "",
        "places_categories": false,
        "locations": [{
            lat: -33.890542,
            lng: 151.274856,
            address: "",
            tooltip: false,
            marker_svg: false,
            marker_svg_file: false,
            image_src: "",
            image_alt: "",
            info_title: "",
            info_text: "",
            info_btn: "",
            info_btn_url: "",
            info_btn_target: "",
        }],
    }, options);

    var markers = [];
    var bounds = new google.maps.LatLngBounds();
    var directionsDisplayOptions = {
        suppressMarkers: true
    };
    var directionsService = new google.maps.DirectionsService;
    var directionsDisplay = new google.maps.DirectionsRenderer;
    directionsDisplay.setOptions( directionsDisplayOptions );

    // var offsetHeight = $("nav.navbar").position();
    var offsetHeight = $("nav.navbar").height() * 2;

    var map = new google.maps.Map(el[0], {
        zoom: settings.zoom,
        zoomControl: true,
        scaleControl: false,
        scrollwheel: false,
        styles: settings.styles ? settings.styles : "",
        streetViewControl: false,
        disableDoubleClickZoom: true,
        mapTypeControl: false,
        fullscreenControl: false
    });

    $.each(settings.locations, function (i, attr) {

        var locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
        var infoButtonString = "";
        var infoImageUrl = "";
        var markerInfowindow = false;
        var icon = false;

        if (attr.info_btn_url) {
            infoButtonString = "<p><a href=\"" + attr.info_btn_url + "\" target=\"" + attr.info_btn_target + "\">" + attr.info_btn + "</a></p>";
        }

        if (attr.image_src) {
            infoImageUrl = "<div class=\"side-gmap\"><img src=\"" + attr.image_src + "\" alt=\"" + attr.image_alt + "\" /></div>";
        }

        if (attr.marker_svg_file) {
            icon = {
                url: attr.marker_svg_file,
                anchor: new google.maps.Point(20, 80),
                scaledSize: new google.maps.Size(40, 80),
            };
        }

        if (attr.info_text || attr.info_title) {
            var contentString =
                "<div class=\"map-infowindow\">" +
                infoImageUrl +
                "<div class=\"main-gmap\">" +
                "<h3 class=\"text-dark\">" + attr.info_title + "</h3>" +
                "<div class=\"text-dark\">" + attr.info_text +
                infoButtonString +
                "</div>" +
                "</div>" +
                "</div>";

            markerInfowindow = new google.maps.InfoWindow({
                content: contentString
            });
        }

        var marker = new google.maps.Marker({
            position: locLatLng,
            map: map,
            icon: icon ? icon : "",
            draggable: false,
            zIndex: -20,
            infowindow: markerInfowindow ? markerInfowindow : false,
        });

        markers.push(marker);

        marker.addListener("click", function () {
            hideAllInfoWindows(map);
            if (this.infowindow) {
                this.infowindow.open(map, this);
            }
            map.setCenter(this.getPosition());
            map.panTo(this.getPosition());

            if (offsetHeight) {
                map.panBy(0, -offsetHeight);
            }
        });

        map.panTo(marker.getPosition());

        // if (offsetHeight && window.innerWidth > 768) {
        //     map.panBy(0, -offsetHeight);
        // }

        bounds.extend(locLatLng);

        if (attr.routes) {
            if (Object.keys(attr.routes).length > 1) {
                if ($("#collapse-location-routes.collapse").length > 0 && $(window).height() > 767) {
                    $("#collapse-location-routes.collapse").collapse();
                }

                $("#location-routes .list-group-item-action").on("click", function (e) {
                    e.preventDefault();
                    $("#location-place-categories").find(".list-group-item-action.active").removeClass("active");
                    var elId = $(this).attr("id");
                    $.each(attr.routes, function (k, routeAttr) {
                        if (elId === routeAttr.title.toLowerCase()) {
                            clearMarkers();
                            var routeLocLatLng = new google.maps.LatLng(routeAttr.lat, routeAttr.lng);
                            calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);
                        }
                    });
                });
            }
        }
    });

    if (settings.places_categories) {
        var placeMarkers = [];

        $("#location-place-categories .list-group-item-action").on("click", function (e) {
            e.preventDefault();
            $("#location-routes").find(".list-group-item-action.active").removeClass("active");

            if ($(this).find(".place-category-icon")) {
                var markerColor = $(this).find(".place-category-icon").css("background-color");
            }

            // Clear directions if any
            directionsDisplay.setMap(null);
            clearMarkers();

            var elId = $(this).attr("id");

            $.each(settings.places_categories, function (title, placesCategory) {
                if (elId === placesCategory.title) {
                    $.each(placesCategory.places, function (title, place) {

                        var placeMarkerInfowindow = false;
                        var placeIcon = {
                            // anchor: new google.maps.Point(0, 0),
                            strokeColor: markerColor,
                            path: "M75.85 68.35L42.5 110 9.15 68.35A41.83 41.83 0 0 1 0 42.21C0 18.94 19.06 0 42.5 0S85 18.93 85 42.2c0 9.87-3.42 18.95-9.15 26.14zM42.5 22.65c-10.55 0-19.13 8.52-19.13 19s8.58 19 19.13 19 19.13-8.52 19.13-19-8.58-19-19.13-19zm0 7.6",
                            fillColor: markerColor,
                            fillOpacity: 1,
                            // scaledSize: new google.maps.Size(1, 1),
                            scale: 0.5,
                            // strokeWeight: 0,
                            // rotation: 0
                        };

                        if (placesCategory.marker_svg_file) {
                            placeIcon = {
                                url: placesCategory.marker_svg_file,
                                // anchor: new google.maps.Point(0, 0),
                                strokeColor: markerColor,
                                fillColor: markerColor,
                                fillOpacity: 1,
                                // scaledSize: new google.maps.Size(8, 8),
                                scale: 1,
                                // strokeWeight: 0,
                                // rotation: 0
                            };
                        }

                        if (place.title || place.description) {
                            var placeContentString = "<div>";

                            if (place.title) {
                                placeContentString = placeContentString + "<h5 class=\"\">" + place.title + "</h5>";
                            }
                            if (place.description) {
                                placeContentString = placeContentString + "<p class=\"mb-0\">" + place.description + "</p>";
                            }
                            placeContentString = placeContentString + "</div>";

                            placeMarkerInfowindow = new google.maps.InfoWindow({
                                content: placeContentString
                            });
                        }

                        var placeLocLatLng = new google.maps.LatLng(place.lat, place.lng);

                        var placeMarker = new google.maps.Marker({
                            position: placeLocLatLng,
                            map: map,
                            draggable: false,
                            icon: placeIcon ? placeIcon : "",
                            zIndex: -20,
                            infowindow: placeMarkerInfowindow ? placeMarkerInfowindow : false,
                        });

                        placeMarkers.push(placeMarker);
                        bounds.extend(placeLocLatLng);
                        map.fitBounds(bounds);
                        map.setCenter(bounds.getCenter());
                        map.setZoom(map.getZoom()-1);
                        map.panTo(bounds.getCenter());
                        if (offsetHeight) {
                            map.panBy(0, -offsetHeight);
                        }
                        // if (Object.keys(settings.locations).length > 1) {
                        //     map.fitBounds(bounds);
                        // }
                        // else if (Object.keys(settings.locations).length === 1) {
                        //     map.setZoom(settings.zoom-1);
                        // }

                        placeMarker.addListener("click", function () {
                            hideAllPlacesInfoWindows(map, placeMarkers);
                            if (this.infowindow) {
                                this.infowindow.open(map, this);
                            }
                            map.setCenter(this.getPosition());
                            map.panTo(this.getPosition());

                            if (offsetHeight) {
                                map.panBy(0, -offsetHeight);
                            }
                        });
                    });
                }
            });
        });
    }

    if (Object.keys(settings.locations).length > 1) {
        map.fitBounds(bounds);
    }
    else if (Object.keys(settings.locations).length === 1) {
        map.setZoom(settings.zoom);
    }

    function hideAllInfoWindows(map) {
        markers.forEach(function (marker) {
            if (marker.infowindow) {
                marker.infowindow.close(map, marker);
            }
        });
    }

    function calculateAndDisplayRoute(directionsService, directionsDisplay, start, end) {
        directionsService.route({
            origin: start,
            destination: end,
            travelMode: "DRIVING"
        }, function(response, status) {
            if (status === "OK") {
                directionsDisplay.setDirections(response);
                directionsDisplay.setMap(map);
                // if (offsetHeight) {
                //     map.panBy(500, +offsetHeight);
                // }
                map.setCenter(this.locLatLng);
            } else {
                window.alert("Directions request failed due to " + status);
            }
        });
    }

    function hideAllPlacesInfoWindows(map, placeMarkers) {
        placeMarkers.forEach(function (placeMarker) {
            if (placeMarker.infowindow) {
                placeMarker.infowindow.close(map, placeMarker);
            }
        });
    }

    // Removes the markers from the map, but keeps them in the array.
    function clearMarkers() {
        setMapOnAll(null);
    }

    // Sets the map on all markers in the array.
    function setMapOnAll(map) {
        for (var i = 0; i < placeMarkers.length; i++) {
            placeMarkers[i].setMap(map);
        }
    }
};
